import { Badge, Tab, TabList, TabPanel, TabPanels, Tabs, Td, Tr } from "@chakra-ui/react";
import { Pressable, Profile, Show, Table, Tag } from "components";
import { Mask } from "config";
import { useNavigate } from "react-router";

export default function Extract({ data }){

    const navigate = useNavigate()

    return(
    <Tabs size="sm" colorScheme="orange">
        <TabList>
            <Tab children="Bônus" />
            <Tab children="Pontos" />
        </TabList>
        <TabPanels>
            <TabPanel>

                <Table columns={[{ children: 'Nível', isNumeric: true }, { children: 'Consultor' }, { children: 'Bônus (R$)', isNumeric: true }]}>
                    { data?.bonus?.map(item => <Tr key={item.id}>
                        <Td isNumeric><Badge children={`${item.level}º nível`} /></Td>
                        <Td>{item.consultant?.customer ? <Pressable onClick={() => navigate(`/consultants/${item.consultant.id}`)}><Profile name={item.consultant.customer.name} /></Pressable> : 'Usuário expirado'}</Td>
                        <Td isNumeric><Tag size="sm" colorScheme={item.use_bonus ? 'teal' : 'red'} children={`R$ ${Mask.price(item.bonus)}`} /></Td>
                    </Tr>)}
                </Table>

            </TabPanel>
            <TabPanel>

                <Table columns={[{ children: 'Nível', isNumeric: true }, { children: 'Consultor' }, { children: 'Pontos', isNumeric: true }]}>
                    { data?.points?.map(item => <Tr key={item.id}>
                        <Td isNumeric><Badge children={`${item.level}º nível`} /></Td>
                        <Td>{item.consultant?.customer ? <Pressable onClick={() => navigate(`/consultants/${item.consultant.id}`)}><Profile name={item.consultant.customer.name} /></Pressable> : 'Usuário expirado'}</Td>
                        <Td isNumeric>
                            <Show visible={item.type === 2}><Tag size="sm" mr={2}>Ponto pessoal</Tag></Show>
                            <Tag size="sm" colorScheme={item.use_points ? 'blue' : 'red'} children={Mask.price(item.points)} />
                        </Td>
                    </Tr>)}
                </Table>

            </TabPanel>
        </TabPanels>
    </Tabs>
    )
}